up.migrate.renamedProperty(up.RenderJob.prototype, 'options', 'renderOptions', 'up.RenderJob: Property { options } has been renamed to { renderOptions }');
